  window.onload = function () {
    function updateWishlistClass() {
      const wishtListHero = document.getElementById('wishlist-hero-shared-list-view');
      if(!wishtListHero) {
        return;
      }
      const empty = document.querySelectorAll('.wishlist-hero-list-no-items-content');
      if (empty.length === 0) {
        document.body.classList.add('wishlist-content');
        document.body.classList.remove('wishlist-empty');
      } else {
        document.body.classList.add('wishlist-empty');
        document.body.classList.remove('wishlist-content');
      }
    }

    const observer = new MutationObserver((mutations, obs) => {
      updateWishlistClass();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  };
